






import { Component, Vue, Prop } from 'vue-property-decorator';

type ILabelInfo = ILabel.IResponse.ILabelInfo;

@Component
export default class LabelList extends Vue {
  @Prop({default: () => []}) private labels!: ILabelInfo[];
  @Prop({default: () => ({display: 'inline-block'})}) private boxStyle!: any;
}
